import React, { useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { AutoSuggest } from "@folio/stripes/components";
var submitEnclosingFormUnlessDefaultButtonDisabled = function (element) {
    var form = element.closest("form");
    var defaultButton = form === null || form === void 0 ? void 0 : form.querySelector('button[type="submit"], input[type="submit"]');
    if (!form || (defaultButton === null || defaultButton === void 0 ? void 0 : defaultButton.disabled)) {
        return;
    }
    form.requestSubmit();
};
export var RecekAutoSuggest = function (_a) {
    var labelId = _a.labelId, _b = _a.showLabel, showLabel = _b === void 0 ? true : _b, value = _a.value, onChange = _a.onChange, suggestions = _a.suggestions, placeholder = _a.placeholder;
    var formatMessage = useIntl().formatMessage;
    var _c = useState(0), resetKey = _c[0], setResetKey = _c[1];
    var lastValue = useRef(value);
    var wrapperRef = useRef(null);
    var pendingSubmitValue = useRef(null);
    var items = useMemo(function () { return suggestions.map(function (name) { return ({ value: name }); }); }, [suggestions]);
    // AutoSuggest keeps its own input state after mount; remount is the only way to clear it on external reset
    useEffect(function () {
        if (value === "" && lastValue.current !== "") {
            setResetKey(function (key) { return key + 1; });
        }
        lastValue.current = value;
    }, [value]);
    useEffect(function () {
        if (pendingSubmitValue.current === null) {
            return;
        }
        var expectedValue = pendingSubmitValue.current;
        pendingSubmitValue.current = null;
        if (expectedValue === value && wrapperRef.current) {
            submitEnclosingFormUnlessDefaultButtonDisabled(wrapperRef.current);
        }
    }, [value]);
    var handleKeyDownCapture = function (event) {
        var _a, _b;
        pendingSubmitValue.current = null;
        if (event.key !== "Enter" || event.nativeEvent.isComposing) {
            return;
        }
        var input = event.target;
        // downshift swallows Enter while its menu is open (preventDefault), which cancels the form's implicit submit
        if (input.getAttribute("aria-expanded") !== "true") {
            return;
        }
        var highlightedId = input.getAttribute("aria-activedescendant");
        var highlightedValue = highlightedId
            ? ((_b = (_a = document.getElementById(highlightedId)) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : null)
            : null;
        if (highlightedValue === null || highlightedValue === value) {
            submitEnclosingFormUnlessDefaultButtonDisabled(input);
            return;
        }
        // downshift reports the selected item to onChange only in an effect after commit, so submit once the new value arrives
        pendingSubmitValue.current = highlightedValue;
    };
    return (React.createElement("div", { ref: wrapperRef, onKeyDownCapture: handleKeyDownCapture },
        React.createElement(AutoSuggest, { key: resetKey, label: showLabel ? formatMessage({ id: labelId }) : undefined, value: value, onChange: onChange, items: items, includeItem: function () { return true; }, placeholder: placeholder })));
};
